import React from 'react'
import Image from '../atoms/Image'
import Headline from '../atoms/Headline'
import Richtext from '../atoms/Richtext'
import Link from '../atoms/Link'
import SbEditable from 'storyblok-react'

const FeatureTeaserBlock = ({ block }) => {
  return (
    <SbEditable content={block}>
      <section
        className={`feature-teaser-block ${
          block.mirrored ? 'feature-teaser-block-mirrored' : ''
        }`}
      >
        <div className="feature-teaser-block-container">
          <div className="feature-teaser-block-wrapper">
            <div className="row">
              <div
                className="feature-teaser-block-image"
                data-rellax-center={true}
                data-rellax-speed={1}
              >
                <Image image={block.image} alt={block.alt} />
              </div>
              <div className="feature-teaser-block-content">
                <Headline headline={block.headline} headline_level="h3" />
                <Richtext text={block.text} />
                {block.link_text?.length > 0 && (
                  <Link link={block.link} className="btn btn-primary">
                    {block.link_text}
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default FeatureTeaserBlock
